import React, { useEffect, useState } from 'react';
import { SocketContext } from './UserContext';
import { io } from "socket.io-client";

export const SocketProvider = ({ children, serverUrl }) => {
  const [socket, setSocket] = useState(null);
  useEffect(() => {
    const newSocket = io(serverUrl, { transports: ["websocket"] });

    newSocket.on("connect", () => {
      console.log("Socket connected:", newSocket.id);
    });

    newSocket.on("disconnect", () => {
      console.log("Socket disconnected");
    });
    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
    };
  }, [serverUrl]);

  return (
    <SocketContext.Provider value={{ socket }}>
      {children}
    </SocketContext.Provider>
  );
};
